import { UserManager } from "oidc-client";

const config = {
  authority: `${process.env.REACT_APP_SSO_BASE_URL_AUTH}/realms/firouzeh`,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: `${process.env.REACT_APP_SSO_BASE_REDIRECT_URL}/callback`,
  silent_redirect_uri: `${process.env.REACT_APP_SSO_BASE_REDIRECT_URL}/home`,
  response_type: process.env.REACT_APP_CLIENT_RESPONSE_TYPE,
  scope: process.env.REACT_APP_CLIENT_SCOPE,
  post_logout_redirect_uri: `${process.env.REACT_APP_SSO_BASE_REDIRECT_URL}/`,
  clockSkew: 86400,
};

const userManager = new UserManager(config);
let refreshingToken = null;
const AuthService = {
  getUser: () => userManager.getUser(),
  login: () => {
    userManager.signinRedirect();
  },
  logout: () => userManager.signoutRedirect(),
  signInSilent: () => userManager.signinSilent(),
  signInSilentCallback: () => userManager.signinSilentCallback(),
  signinRedirectCallback: () => userManager.signinRedirectCallback(),
  refreshToken: async () => {
    if (!refreshingToken) {
      refreshingToken = userManager
        .signinSilent()
        .then((user) => {
          if (user) {
            userManager.storeUser(user);
          }
          refreshingToken = null;
          return user;
        })
        .catch((error) => {
          refreshingToken = null;
          throw error;
        });
    }

    return refreshingToken;
  },
};

export default AuthService;
